import { render, staticRenderFns } from "./Checkpoint.vue?vue&type=template&id=23b7efc2&"
import script from "./Checkpoint.vue?vue&type=script&lang=js&"
export * from "./Checkpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports